import styled from 'styled-components';

export const FeatureTextWrapper = styled.p`
  color: ${props => props.theme.featureText.color};
	font-family: ${props => props.theme.font};
  font-size: 14px;
`;

export const FeatureTextText = styled.span`
  font-weight: 600;
  span {
    font-weight: 400;
  }
`;
